import { render, staticRenderFns } from "./RelationWidgetInput.vue?vue&type=template&id=7e4d152e&"
import script from "./RelationWidgetInput.vue?vue&type=script&lang=js&"
export * from "./RelationWidgetInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4d152e')) {
      api.createRecord('7e4d152e', component.options)
    } else {
      api.reload('7e4d152e', component.options)
    }
    module.hot.accept("./RelationWidgetInput.vue?vue&type=template&id=7e4d152e&", function () {
      api.rerender('7e4d152e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/inputs/RelationWidgetInput.vue"
export default component.exports